import { render, staticRenderFns } from "./NewContainerType.vue?vue&type=template&id=620b5984&"
import script from "./NewContainerType.vue?vue&type=script&lang=js&"
export * from "./NewContainerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports